import { Container } from '../../common/container/Container'

export type DownloadsRegisterContainerConfig = {
  moduleFullUrl: string
}

export type DownloadRegisterProps = {
  parentContainer: Container
  config: DownloadsRegisterContainerConfig
}

export const DOWNLOADSREGISTER_API_KEY = Symbol('DOWNLOADSREGISTER_API_KEY')
export const DOWNLOADSREGISTER_SERVICE_KEY = Symbol('DOWNLOADSREGISTER_SERVICE_KEY')
export const DOWNLOADSREGISTER_MODULE = Symbol('DOWNLOADSREGISTER_MODULE')
